// import React, { useState }  from 'react';
// import { Link } from 'react-router-dom';
// import './Home.css';
// // Import the image directly
// import profileImage from '../assets/aditi.jpg'; // Adjust the path based on your project structure

// function Home() {
// const [showAllProjects, setShowAllProjects] = useState(false);
// const projectsToShow = showAllProjects ? [1, 2, 3, 4, 5, 6] : [1, 2, 3];

// const toggleProjects = () => {
//   setShowAllProjects(!showAllProjects);
// };

//   const resumePDF = '#'; 

//   return (
//     <div className="home-container">
//       {/* Hero Section */}
//       <section className="hero-section">
//         <div className="hero-content">
//           {/* Left Side - Profile Image */}
//           <div className="profile-container">
//             <div className="profile-image-wrapper">
//               <img
//                 src={profileImage}
//                 alt="Profile"
//                 className="profile-image"
//                 onError={(e) => {
//                   console.error("Image failed to load");
//                   e.target.src = 'https://via.placeholder.com/300x300?text=Profile+Image';
//                 }}
//               />
//               <div className="experience-badge">
//                 <span className="experience-badge-text">2+</span>
//                 <span className="experience-badge-subtext">Years</span>
//               </div>
//             </div>
//           </div>

//           {/* Right Side - Summary */}
//           <div className="summary-container">
//             <h2 className="name-title">
//               Hello, I'm <span className="name-highlight">Aditi Singh</span>
//             </h2>
//             <h3 className="job-title">
//               Full Stack Developer
//             </h3>
//             {/* <p className="bio-text">
//               Full Stack Web & Mobile Application Developer with 3 years of experience in designing, developing, deploying, and maintaining high-quality, responsive, and user-focused digital solutions. Proficient in React.js, React Native, Node.js, Express.js, MongoDB, and modern web technologies, with expertise in building both web platforms and cross-platform mobile applications.

//               Experienced in the end-to-end development lifecycle—from requirement gathering and UI/UX design to backend development, API integration, testing, production deployment, and post-launch support. Skilled at optimizing application performance, ensuring security, and delivering scalable solutions for real-world business needs.
// <br></br>
//               <b> Highlights: </b>

//               E-commerce platforms – Scalable websites with secure payment gateways, product management, and live order tracking.

//               Mobile healthcare apps – Cross-platform apps with patient management, appointment booking, and real-time updates.

//               Real-time chat systems – Secure messaging apps with instant notifications, multimedia sharing, and group chats.

//               Interactive games – Engaging web-based games optimized for speed and user interaction.

//               Productivity tools – Task management and scheduling apps for personal and enterprise use.
//             </p> */}


//             <p className="bio-text">
//               Full Stack Web &amp; Mobile Application Developer with <b>3 years</b> of experience in designing, developing, deploying, and maintaining high-quality, responsive, and user-focused digital solutions. Proficient in <b>React.js</b>, <b>React Native</b>, <b>Node.js</b>, <b>Express.js</b>, <b>MongoDB</b>, and modern web technologies, with expertise in building both web platforms and cross-platform mobile applications.

//               <br /><br />

//               Experienced in the end-to-end development lifecycle — from requirement gathering and UI/UX design to backend development, API integration, testing, <b>production deployment</b>, and post-launch support. Skilled at optimizing application performance, ensuring security, and delivering scalable solutions for real-world business needs.
//               Strong expertise in building dynamic, component-driven user interfaces using <b>React.js</b>, state management with <b>Redux</b>, and reusable UI components for maintainable codebases.

//               <br /><br />

//               <b>Highlights:</b>
//               <ul>
//                 <li><b>E-commerce platforms</b> – Scalable websites with secure payment gateways, product management, and live order tracking.</li>
//                 <li><b>Mobile healthcare apps</b> – Cross-platform apps with patient management, appointment booking, and real-time updates.</li>
//                 <li><b>Real-time chat systems</b> – Secure messaging apps with instant notifications, multimedia sharing, and group chats.</li>
//                 <li><b>Interactive games</b> – Engaging web-based games optimized for speed and user interaction.</li>
//                 <li><b>Productivity tools</b> – Task management and scheduling apps for personal and enterprise use.</li>
//               </ul>
//             </p>

//             <div className="buttons-container">
//               <a
//                 href={resumePDF}
//                 download="Aditi_Singh_Resume.pdf"
//                 className="primary-button"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" className="button-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                 </svg>
//                 Download CV
//               </a>
//               <Link
//                 to="/contact"
//                 className="secondary-button"
//               >
//                 Contact Me
//               </Link>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Skills Section */}
//       {/* <section className="skills-section">
//         <h2 className="section-title">
//           My <span className="section-title-highlight">Skills</span>
//         </h2>
//         <div className="skills-grid">
//           {['React', 'JavaScript', 'Node.js', 'HTML5', 'CSS3', 'Tailwind CSS', 'MongoDB', 'Express', 'Git', 'UI/UX', 'Responsive Design', 'RESTful APIs'].map((skill, index) => (
//             <div
//               key={index}
//               className="skill-item"
//             >
//               <span className="skill-text">{skill}</span>
//             </div>
//           ))}
//         </div>
//       </section> */}

// <section className="skills-section">
//   <h2 className="section-title">
//     More Skills - My <span className="section-title-highlight">Skills</span>
//   </h2>

//   <div className="skills-grid">
//     {[
//       // Full Stack
//       'MEAN Stack', 'MERN Stack', 'MEVN Stack',

//       // Languages & Frameworks
//       'JavaScript (ES6+)', 'Node.js', 'NestJS', 'Express.js', 'Django', 'Flask', 'Python', 'PHP',

//       // Frontend
//       'HTML5', 'CSS3', 'React.js', 'Vue.js', 'Next.js', 'Nuxt.js', 'Redux', 'Bootstrap', 'Tailwind CSS', 'Material UI (MUI)', 'Framer Motion',

//       // Backend
//       'RESTful API Development', 'Authentication & Security (OAuth2, JWT, Bcrypt, CORS)', 'Secure File Uploads', 'Gmail OTP',

//       // Databases
//       'MySQL', 'PostgreSQL', 'MSSQL', 'MongoDB (Mongoose)', 'Firebase',

//       // Cloud & DevOps
//       'AWS (EC2, S3)', 'Google Cloud Storage (GCS)', 'DigitalOcean', 'Docker', 'Docker Compose', 'NGINX', 'Webpack', 'GitHub Actions', 'Vercel', 'Render',

//       // Tools & Others
//       'Git', 'GitHub', 'Postman', 'VS Code', 'Payment Gateways', 'GPS Tracking', 'Push Notifications', 'AutoCAD', 'AI/ML Integration',
//       , 'Client Communication', 
//     ].map((skill, index) => (
//       <div key={index} className="skill-item">
//         <span className="skill-text">{skill}</span>
//       </div>
//     ))}
//   </div>
// </section>


//       {/* Featured Projects Section */}
//       {/* <section className="projects-section">
//         <h2 className="section-title">
//           Featured <span className="section-title-highlight">Projects</span>
//         </h2>
//         <div className="projects-grid">
//           {[1, 2, 3, 4,5,6].map((project) => (
//             <div
//               key={project}
//               className="project-card"
//             >
//               <div className="project-image">
//                 <img
//                   src={`https://via.placeholder.com/600x400?text=Project+${project}`}
//                   alt={`Project ${project}`}
//                 />
//               </div>
//               <div className="project-content">
//                 <h3 className="project-title">Project {project}</h3>
//                 <p className="project-description">
//                   A brief description of project {project} and the technologies used to build it.
//                 </p>
//                 <div className="project-tags">
//                   {['React', 'Node.js', 'MongoDB'].map((tech, index) => (
//                     <span
//                       key={index}
//                       className="project-tag"
//                     >
//                       {tech}
//                     </span>
//                   ))}
//                 </div>
//                 <div className="project-links">
//                   <a
//                     href="#"
//                     className="project-link"
//                   >
//                     View Project
//                   </a>
//                   <a
//                     href="#"
//                     className="project-link"
//                   >
//                     GitHub
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="view-all-container">
//           <Link
//             to="/projects"
//             className="primary-button"
//           >
//             View All Projects
//           </Link>
//         </div>
//       </section> */}



// {/* Featured Projects Section */}
// <section className="projects-section">
//   <h2 className="section-title">
//      <span className="section-title-highlight">Projects</span>
//   </h2>
//   <div className="projects-grid">
//     {projectsToShow.map((project) => ( // Use the state variable to determine which projects to show
//       <div
//         key={project}
//         className="project-card"
//       >
//         {/* <div className="project-image">
//           <img
//             src={`https://via.placeholder.com/600x400?text=Project+${project}`}
//             alt={`Project ${project}`}
//           />
//         </div> */}
//         <div className="project-content">
//           <h3 className="project-title">Project {project}</h3>
//           <p className="project-description">
//             {/* A brief description of project {project} and the technologies used to build it. */}
//           </p>
//           <div className="project-tags">
//             {['React', 'Node.js', 'MongoDB'].map((tech, index) => (
//               <span
//                 key={index}
//                 className="project-tag"
//               >
//                 {tech}
//               </span>
//             ))}
//           </div>
//           <div className="project-links">
//             <a
//               href="#"
//               className="project-link"
//             >
//               View Project
//             </a>
//             <a
//               href="#"
//               className="project-link"
//             >
//               GitHub
//             </a>
//           </div>
//         </div>
//       </div>
//     ))}
//   </div>
//   <div className="view-all-container">
//     <button
//       onClick={toggleProjects}
//       className="primary-button"
//     >
//       {showAllProjects ? 'Show Less Projects' : 'View All Projects'}
//     </button>
//   </div>
// </section>


//       {/* Call to Action */}
//       <section className="cta-section">
//         <div className="cta-container">
//           <div className="cta-card">
//             <h2 className="cta-title">Ready to work together?</h2>
//             <p className="cta-description">
//               I'm currently available for freelance work or full-time positions.
//               If you're interested in working together, let's get in touch!
//             </p>
//             <Link
//               to="/contact"
//               className="cta-button"
//             >
//               Get In Touch
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Home;





import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import profileImage from '../assets/aditi.jpg'; // your profile image

// ✅ Step 1: Define project data
const projectsData = [
  {
    id: 1,
    title: "E-commerce Platform",
    description: "A scalable online shopping platform with secure payments and live order tracking.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAEUmb6rovbvv4gwYkwO6WJiHvEVVBkbtZnw&s",
    tech: ["React", "Node.js", "MongoDB"],
    liveLink: "https://your-live-link.com",
    github: "https://github.com/kumariaditi52/Ecommerce"
  },
  {
    id: 2,
    title: "Healthcare App",
    description: "Cross-platform app for patient management and appointment booking.",
    image: "https://kanopi.com/wp-content/uploads/2023/08/Hospital-web-development_ClevelandClinic.png",
    tech: ["React.js", "Node.js", "MongoDB"],
    liveLink: "https://healthcare-app-lilac.vercel.app/",
    github: "https://github.com/kumariaditi52/HealthcareApp"
  },
  {
    id: 3,
    title: "school-management-system-web",
    description: "A secure messaging app with instant notifications and group chats.",
    image: "https://repository-images.githubusercontent.com/221053244/37859480-127b-11ea-902b-9e587bbf2372",
    tech: ["React", "mongooDB", "Node.js"],
    liveLink: "https://school-management-system-web-sigma.vercel.app/",
    github: "https://github.com/your-repo"
  },
  {
    id: 4,
    title: "Hotel Management system",
    description: "A responsive personal portfolio to showcase my projects and skills.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDGesHZGF7J4XTy411qTfFIWBmTV55QPHyYg&s",
    tech: ["react.js", "Tailwind CSS", "node.js", "mongooDB"],
    liveLink: "https://hotel-management-web-25-git-main-aditi-singhs-projects-237e797c.vercel.app/login",
    github: "https://github.com/kumariaditi52/Hotel-Management-System"
  },
  {
    id: 5,
    title: " Data-manager Task Manager",
    description: "A productivity tool for task management and scheduling.",
    image: "https://arches.readthedocs.io/en/stable/_images/arches-designer-afs-collection-or-set-name-branch.png",
    tech: ["reactjs ", "pythone", "sql", "flask"],
    liveLink: "https://your-live-link.com",
    github: "https://github.com/kumariaditi52/fullstack-flask-react-sql"
  },
  {
    id: 6,
    title: "zomato-mobile-application",
    description: "A Zomato-like mobile application for food ordering, restaurant search, and real-time delivery tracking",
    image: "https://deorwineblog.b-cdn.net/uploads/2024/02/Deorwine-Blog-ZomotoApp.-1024x512.jpg",
    tech: ["ReactNative", "node.js ", "mongooDb"],
    liveLink: "https://your-live-link.com",
    github: "https://github.com/kumariaditi52/zomato-mobile-application"
  }
];

function Home() {
  const [showAllProjects, setShowAllProjects] = useState(false);

  const toggleProjects = () => {
    setShowAllProjects(!showAllProjects);
  };

  const resumePDF = '#'; // replace with actual resume path

  return (
    <div className="home-container">



      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          {/* Left Side - Profile Image */}
          <div className="profile-container">
            <div className="profile-image-wrapper">
              <img
                src={profileImage}
                alt="Profile"
                className="profile-image"
                onError={(e) => {
                  console.error("Image failed to load");
                  e.target.src = 'https://via.placeholder.com/300x300?text=Profile+Image';
                }}
              />
              <div className="experience-badge">
                <span className="experience-badge-text">2+</span>
                <span className="experience-badge-subtext">Year</span>
              </div>
            </div>
          </div>


          {/* Right Side - Summary */}
          <div className="summary-container">
            <h2 className="name-title">
              Hello, I'm <span className="name-highlight">Aditi Singh</span>
            </h2>
            <h3 className="job-title">Full Stack Developer</h3>

            <p className="bio-text">
              Full Stack Web &amp; Mobile Application Developer with <b>3year 2months</b> of experience in designing,
              developing, deploying, and maintaining high-quality, responsive, and user-focused digital solutions.
              Proficient in <b>React.js</b>, <b>React Native</b>, <b>Node.js</b>, <b>Express.js</b>, <b>MongoDB</b>, and
              modern web technologies, with expertise in building both web platforms and cross-platform mobile applications.
              <br /><br />
              Experienced in the end-to-end development lifecycle — from requirement gathering and UI/UX design to backend
              development, API integration, testing, <b>production deployment</b>, and post-launch support.
              <br /><br />
              <b>Highlights:</b>
              {/* <ul>
                <li><b>E-commerce platforms</b> – Scalable websites with secure payment gateways.</li>
                <li><b>Mobile healthcare apps</b> – Cross-platform apps with patient management.</li>
                <li><b>Real-time chat systems</b> – Secure messaging apps with instant notifications.</li>
                <li><b>Interactive games</b> – Engaging web-based games optimized for speed.</li>
                <li><b>Productivity tools</b> – Task management and scheduling apps.</li>
              </ul> */}



              <ul className="highlights-list">
                <li>
                  <span className="highlight-icon">🛒</span>
                  <span><b>E-commerce platforms</b> – Scalable websites with secure payment gateways.</span>
                </li>
                <li>
                  <span className="highlight-icon">💊</span>
                  <span><b>Mobile healthcare apps</b> – Cross-platform apps with patient management.</span>
                </li>
                <li>
                  <span className="highlight-icon">💬</span>
                  <span><b>Real-time chat systems</b> – Secure messaging apps with instant notifications.</span>
                </li>
                <li>
                  <span className="highlight-icon">🎮</span>
                  <span><b>Interactive games</b> – Engaging web-based games optimized for speed.</span>
                </li>
                <li>
                  <span className="highlight-icon">🗂️</span>
                  <span><b>Productivity tools</b> – Task management and scheduling apps.</span>
                </li>
              </ul>

            </p>

            <div className="buttons-container">
              <a href={resumePDF} download="3_Year_Exp_Full_Stack_Resume_Aditi_Singh.pdf" className="primary-button">
                <svg xmlns="http://www.w3.org/2000/svg" className="button-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download CV
              </a>
              <Link to="/contact" className="secondary-button">Contact Me</Link>
            </div>
          </div>
        </div>
      </section>




      {/* Skills Section */}
      {/* <section className="skills-section">
        <h2 className="section-title">
          More Skills - My <span className="section-title-highlight">Skills</span>
        </h2>
        <div className="skills-grid">
          {[
            'MEAN Stack', 'MERN Stack', 'MEVN Stack',
            'JavaScript (ES6+)', 'Node.js', 'NestJS', 'Express.js', 'Django', 'Flask', 'Python', 'PHP',
            'HTML5', 'CSS3', 'React.js', 'Vue.js', 'Next.js', 'Nuxt.js', 'Redux', 'Bootstrap', 'Tailwind CSS',
            'Material UI (MUI)', 'Framer Motion',
            'RESTful API Development', 'Authentication & Security (OAuth2, JWT, Bcrypt, CORS)',
            'Secure File Uploads', 'Gmail OTP',
            'MySQL', 'PostgreSQL', 'MSSQL', 'MongoDB (Mongoose)', 'Firebase',
            'AWS (EC2, S3)', 'Google Cloud Storage (GCS)', 'DigitalOcean', 'Docker', 'Docker Compose', 'NGINX',
            'Webpack', 'GitHub Actions', 'Vercel', 'Render',
            'Git', 'GitHub', 'Postman', 'VS Code', 'Payment Gateways', 'GPS Tracking',
            'Push Notifications', 'AutoCAD', 'AI/ML Integration', 'Client Communication',
          ].map((skill, index) => (
            <div key={index} className="skill-item">
              <span className="skill-text">{skill}</span>
            </div>
          ))}
        </div>
      </section> */}



      {/* Skills Section */}

      <section className="skills-section">
        <h2 className="section-title">
          More Skills - My <span className="section-title-highlight">Skills</span>
        </h2>
        <div className="skills-grid">
          {[
            'MEAN Stack', 'MERN Stack', 'MEVN Stack',
            'JavaScript (ES6+)', 'Node.js', 'NestJS', 'Express.js', 'Django', 'Flask', 'Python', 'PHP',
            'HTML5', 'CSS3', 'React.js', 'Vue.js', 'Next.js', 'Nuxt.js', 'Redux', 'Bootstrap', 'Tailwind CSS',
            'Material UI (MUI)', 'Framer Motion',
            'RESTful API Development', 'Authentication & Security (OAuth2, JWT, Bcrypt, CORS)',
            'Secure File Uploads', 'Gmail OTP',
            'MySQL', 'PostgreSQL', 'MSSQL', 'MongoDB (Mongoose)', 'Firebase',
            'AWS (EC2, S3)', 'Google Cloud Storage (GCS)', 'DigitalOcean', 'Docker', 'Docker Compose', 'NGINX',
            'Webpack', 'GitHub Actions', 'Vercel', 'Render',
            'Git', 'GitHub', 'Postman', 'VS Code', 'Payment Gateways', 'GPS Tracking',
            'Push Notifications', 'AutoCAD', 'AI/ML Integration', 'Client Communication',
          ].map((skill, index) => (
            <div key={index} className="skill-item">
              <span className="skill-text" data-text={skill}>{skill}</span>
            </div>
          ))}
        </div>
      </section>






      {/* Projects Section */}
      <section className="projects-section">
        <h2 className="section-title"><span className="section-title-highlight">Projects</span></h2>
        <div className="projects-grid">
          {projectsData
            .slice(0, showAllProjects ? projectsData.length : 3)
            .map((project) => (
              <div key={project.id} className="project-card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="project-content">
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">{project.description}</p>
                  <div className="project-tags">
                    {project.tech.map((tech, index) => (
                      <span key={index} className="project-tag">{tech}</span>
                    ))}
                  </div>
                  <div className="project-links">
                    <a href={project.liveLink} target="_blank" rel="noopener noreferrer" className="project-link">
                      View Project
                    </a>
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link">
                      GitHub
                    </a>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="view-all-container">
          <button onClick={toggleProjects} className="primary-button">
            {showAllProjects ? "Show Less Projects" : "View All Projects"}
          </button>
        </div>
      </section>





      {/* Call to Action */}
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-card">
            <h2 className="cta-title">Ready to work together?</h2>
            <p className="cta-description">
              I'm currently available for freelance work or full-time positions.
              If you're interested in working together, let's get in touch!
            </p>
            <Link to="/contact" className="cta-button">Get In Touch</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
